import { lazy } from "react";
import SuspenseWrapper from "components/SuspenseWrapper";

const Brands = lazy(() => import("modules/brands/Brands"));
export default function BrandsPage() {
  return (
    <SuspenseWrapper>
      <Brands />
    </SuspenseWrapper>
  );
}
